import { ChangeDetectionStrategy, Component, input } from '@angular/core';

interface Step {
  stepNumber: number;
  currentOrCompleted: boolean;
}

@Component({
  selector: 'tlc-churn-flow-step-counter',
  templateUrl: './churn-flow-step-counter.component.html',
  styleUrls: ['./churn-flow-step-counter.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChurnFlowStepCounterComponent {
  public steps: Step[] = [];
  public numberOfSteps = input.required<number>();
  public currentStep = input.required<number>();
  public label = input<string>();

  public ngOnInit(): void {
    this.resolveSteps();
  }

  private resolveSteps(): void {
    this.steps = [];
    this.steps = Array.from({ length: this.numberOfSteps() }, (_, i) => ({
      stepNumber: i + 1,
      currentOrCompleted: i + 1 <= this.currentStep(),
    }));
  }
}
